import { Component } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { CardModule } from 'primeng/card';

@Component({
  standalone: true,
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  imports: [RouterModule, CardModule]
})
export class HomeComponent {
  constructor(private router: Router) {}

  navigateTo(path: string) {
    this.router.navigate([`/app/${path}`]);
  }
}
